export const CART_ID = 'cartId'
export const CART_FALLBACK = '_IL-cartId'
export const CART_MIGRABLE = 'cartState'
export const GUEST_CART = 'GUEST_CART'
